<template>
    <v-container fluid>
        <div v-if="!orderLoading">
            <v-row>
                <v-col>
                    <h4 class="text-h4">Create General/Non-Inventory Receipt</h4>
                    <p class="text-subtitle-1">Non-Inventory Receipt Creation Form</p>
                    <v-divider></v-divider>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <GeneralReceiptForm ref="form" v-model="data"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="3">
                    <v-btn block color="primary" @click="handleSave">
                        <v-icon left>mdi-content-save</v-icon>
                        save
                    </v-btn>
                </v-col>
                <v-col cols="12" md="3">
                    <v-btn block depressed @click="handleCancel">
                        cancel
                    </v-btn>
                </v-col>
            </v-row>
        </div>
        <div v-else>
            <v-row>
                <v-col>
                    <v-skeleton-loader type="heading" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-divider></v-divider>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                </v-col>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="d-flex">
                    <v-skeleton-loader type="button" class="my-4 me-4"/>
                    <v-skeleton-loader type="button" class="my-4"/>
                </v-col>
            </v-row>
        </div>
        <PAlert v-model="alert.value" v-bind="alert"/>
    </v-container>
</template>

<script>
import permissions from './../../data/permissions';
import PAlert from '@/components/common/PAlert'
import GeneralReceiptForm from './../../components/purchase/GeneralReceiptForm.vue'
import { mapActions, mapGetters } from 'vuex'
import { v4 as uuid } from 'uuid';
import moment from 'moment';

export default {
    name: "GeneralReceiptCreateView",
    components: {
        GeneralReceiptForm,
        PAlert
    },
    data() {
        return {
            alert: {
                value: false,
                title: "Alert",
                content: "Are you sure",
                callback: null
            },
            loading: false,
            orderLoading: false,
            data: null,
            idempotentKey: null,
            perm: permissions
        }
    },
    computed: {
        ...mapGetters({
            hasPermission: "authentication/hasPermission"
        })
    },
    methods: {
        ...mapActions({
            create: "purchase/generalReceipt/create",
            findOrderByID: "purchase/order/findByID",
            snackbar: "ui/snackbar/show",
            pushItem: "purchase/item/push"
        }),
        handleList() {
            this.$router.push({ name: "GeneralReceiptList"})
        },
        handleNewLine() {
            this.$refs.form.addLine()
        },
        handleSave() {
            this.alert = {...this.alert, content: "Are you sure you want to save?", value: true, callback: this.save}
        },
        save() {
            if(!this.$refs.form.validate()) return;
            this.loading = true;
            this.create({...this.data, idempotentKey: this.idempotentKey}).then(response => {
                this.$router.replace({ name: "GeneralReceiptDisplay", params: { id: response.data.id }})
                this.snackbar({ text: 'General Receipt Create', color: "success"})
            }).catch(error => {
                let message = error.message ? error.response.data.message : error;
                this.snackbar({ text: message, color: "error"})
            }).finally(() => {
                this.loading = false
            })
        },
        fetchOrder(orderID) {
            this.orderLoading = true;
            this.findOrderByID(orderID).then(response => {
                this.data = this.mapOrderToReceipt(response.data);
            }).finally(() => {
                this.orderLoading = false;
            })
        },
        mapOrderToReceipt(order) {
            return {
                date: moment().format("YYYY-MM-DD"),
                purchase_order_code: order.code,
                purchase_order_id: order.id,
                warehouse_id: order.warehouse.id,
                lines: order.lines.map(line => {
                    this.pushItem(line.item)
                    return {
                        item_id: line.item.id,
                        quantity: line.quantity,
                        measure_unit_id: line.measure_unit.id
                    }
                })
            }
        },
        handleCancel() {
            this.alert = {...this.alert, content: "Are you sure you want to discard changes?", value: true, callback: this.cancel}
        },
        cancel() {
            this.$router.back();
        }
    },
    created() {
        if(this.$route.query.order_id) {
            this.fetchOrder(this.$route.query.order_id);
        }
        this.idempotentKey = uuid();
    }
}
</script>

<style>

</style>